/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

function initPage() {
	const prevButtons = document.querySelectorAll(
		'.wp-block-dataperk-form-page__button.prev'
	);

	for ( const button of prevButtons ) {
		button.addEventListener( 'click', previousPage );
	}

	const nextButtons = document.querySelectorAll(
		'.wp-block-dataperk-form-page__button.next'
	);

	for ( const button of nextButtons ) {
		button.addEventListener( 'click', nextPage );
	}
}

function previousPage( event ) {
	event.preventDefault();
	const form = event.target.closest( '.wp-block-dataperk-form' );
	form.dataset.currentPage--;
}

function nextPage( event ) {
	event.preventDefault();
	const form = event.target.closest( '.wp-block-dataperk-form' );
	if( validateCurrentPage( form ) ) {
		form.dataset.currentPage++;
	}
}

function validateCurrentPage( form ) {
	const page = form.querySelector( 'section.current' );

	if( page ) {
		const inputs = page.querySelectorAll('input,textarea');
		for( let input of inputs ) {
			if( ! input.reportValidity() ) {
				return false;
			}
		}
	}

	return true;
}

function ready( fn ) {
	if ( document.readyState !== 'loading' ) {
		fn();
	} else {
		document.addEventListener( 'DOMContentLoaded', fn );
	}
}

ready( initPage );
